import React from 'react';
import { Modal } from '../../modal';
import { ProgressUpdateModal } from '../../modal/progress-update-modal';
import PropTypes from 'prop-types';

const ProgressUpdateModalParent = props => {
    const { previousScores, gameScores, feedback, onClick } = props;

    return (
        <Modal ariaLabel="progress update modal" onClick={onClick} transition>
            <ProgressUpdateModal
                previousScores={previousScores}
                gameScores={gameScores}
                feedback={feedback}
            />
        </Modal>
    );
};

ProgressUpdateModalParent.propTypes = {
    previousScores: PropTypes.objectOf(PropTypes.number).isRequired,
    gameScores: PropTypes.objectOf(PropTypes.number).isRequired,
    feedback: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export { ProgressUpdateModalParent };
